import useSelector from '@app/hooks/useSelector';

import { getExportEmptyOptions } from '../../../../reducers/downloadData/selectors';
import { FileFormat } from '../../../../types';
import type { ExportEmpty, ExportEmptyOptions } from '../../../../types';
import ExportEmptyInput from './ExportEmptyInput';

const filterOptions = (options: ExportEmptyOptions, fileFormat: FileFormat) => {
    if (fileFormat === FileFormat.srt) {
        return options.filter(({ value }) => !['as_null', 'empty'].includes(value));
    }

    if (fileFormat === FileFormat.yamlRuby) {
        return options;
    }

    return options.filter(({ value }) => value !== 'as_null');
};

export interface ExportEmptyInputContainerProps {
    value: ExportEmpty;
    fileFormat: FileFormat;
    onChange: (value: ExportEmpty) => void;
}

const ExportEmptyInputContainer = ({ value, fileFormat, onChange }: ExportEmptyInputContainerProps) => {
    const exportEmptyOptions = useSelector(getExportEmptyOptions);
    const options = filterOptions(exportEmptyOptions, fileFormat);

    return <ExportEmptyInput value={value} options={options} onChange={onChange} />;
};

export default ExportEmptyInputContainer;
